const translation = {
  category: {
    tools: 'Інструмент',
    all: 'Увесь',
    bundles: 'Пакети',
    models: 'Моделі',
    extensions: 'Розширення',
    agents: 'Стратегії агентів',
  },
  categorySingle: {
    agent: 'Стратегія агента',
    bundle: 'Комплектація',
    tool: 'Інструмент',
    extension: 'Збільшення',
    model: 'Модель',
  },
  list: {
    source: {
      local: 'Інсталяція з локального файлу пакета',
      marketplace: 'Інсталяція з Marketplace',
      github: 'Встановлення з GitHub',
    },
    noInstalled: 'Плагіни не встановлено',
    notFound: 'Плагінів не знайдено',
  },
  source: {
    marketplace: 'Ринку',
    local: 'Файл локального пакета',
    github: 'Гітхаб',
  },
  detailPanel: {
    categoryTip: {
      github: 'Встановлено з Github',
      debugging: 'Плагін налагодження',
      local: 'Локальний плагін',
      marketplace: 'Інстальовано з Marketplace',
    },
    operation: {
      viewDetail: 'Переглянути деталі',
      detail: 'Деталі',
      remove: 'Видалити',
      install: 'Інсталювати',
      checkUpdate: 'Перевірити Оновлення',
      update: 'Оновлювати',
      info: 'Інформація про плагін',
    },
    toolSelector: {
      placeholder: 'Виберіть інструмент...',
      descriptionLabel: 'Опис засобу',
      paramsTip1: 'Контролює параметри логічного висновку LLM.',
      toolLabel: 'Інструмент',
      params: 'КОНФІГУРАЦІЯ МІРКУВАНЬ',
      settings: 'НАЛАШТУВАННЯ КОРИСТУВАЧА',
      uninstalledLink: 'Керування в плагінах',
      title: 'Додати інструмент',
      paramsTip2: 'Коли параметр "Автоматично" вимкнено, використовується значення за замовчуванням.',
      empty: 'Натисніть кнопку «+», щоб додати інструменти. Ви можете додати кілька інструментів.',
      uninstalledTitle: 'Інструмент не встановлено',
      descriptionPlaceholder: 'Короткий опис призначення інструменту, наприклад, отримання температури для конкретного місця.',
      unsupportedTitle: 'Непідтримувані дії',
      unsupportedContent2: 'Натисніть, щоб змінити версію.',
      auto: 'Автоматичний',
      uninstalledContent: 'Цей плагін встановлюється з локального/GitHub репозиторію. Будь ласка, використовуйте після встановлення.',
      unsupportedContent: 'Встановлена версія плагіна не передбачає цієї дії.',
      toolSetting: 'Налаштування інструментів',
    },
    modelNum: '{{num}} МОДЕЛІ В КОМПЛЕКТІ',
    switchVersion: 'Версія перемикача',
    configureApp: 'Налаштуйте додаток',
    endpointDeleteTip: 'Видалити кінцеву точку',
    endpoints: 'Кінцеві точки',
    endpointsDocLink: 'Переглянути документ',
    configureModel: 'Налаштування моделі',
    endpointDisableTip: 'Вимкніть кінцеву точку',
    endpointsEmpty: 'Натисніть кнопку «+», щоб додати кінцеву точку',
    actionNum: '{{num}} {{дія}} ВКЛЮЧЕНІ',
    disabled: 'Вимкнуто',
    endpointModalTitle: 'Налаштування кінцевої точки',
    endpointDisableContent: 'Чи хотіли б ви вимкнути {{name}}?',
    endpointDeleteContent: 'Чи хотіли б ви видалити {{name}}?',
    endpointsTip: 'Цей плагін надає конкретні функції через кінцеві точки, і ви можете налаштувати кілька наборів кінцевих точок для поточного робочого простору.',
    strategyNum: '{{num}} {{стратегія}} ВКЛЮЧЕНІ',
    endpointModalDesc: 'Після налаштування можна використовувати функції, що надаються плагіном через кінцеві точки API.',
    configureTool: 'Інструмент налаштування',
    serviceOk: 'Сервіс працює',
  },
  debugInfo: {
    title: 'Налагодження',
    viewDocs: 'Переглянути документи',
  },
  privilege: {
    whoCanDebug: 'Хто може налагоджувати плагіни?',
    admins: 'Адміни',
    noone: 'Ніхто',
    whoCanInstall: 'Хто може встановлювати плагіни та керувати ними?',
    everyone: 'Кожен',
    title: 'Налаштування плагіна',
  },
  pluginInfoModal: {
    repository: 'Сховище',
    release: 'Реліз',
    title: 'Інформація про плагін',
    packageName: 'Пакунок',
  },
  action: {
    deleteContentLeft: 'Чи хотіли б ви видалити',
    usedInApps: 'Цей плагін використовується в додатках {{num}}.',
    deleteContentRight: 'плагін?',
    checkForUpdates: 'Перевірте наявність оновлень',
    delete: 'Видалити плагін',
    pluginInfo: 'Інформація про плагін',
  },
  installModal: {
    labels: {
      package: 'Пакунок',
      repository: 'Сховище',
      version: 'Версія',
    },
    uploadFailed: 'Не вдалося завантажити файл',
    close: 'Закрити',
    installedSuccessfullyDesc: 'Плагін успішно встановлено.',
    readyToInstallPackages: 'Про встановлення наступних плагінів {{num}}',
    install: 'Інсталювати',
    cancel: 'Скасувати',
    readyToInstall: 'Про встановлення наступного плагіна',
    pluginLoadErrorDesc: 'Цей плагін не буде встановлено',
    installComplete: 'Інсталяцію завершено',
    installing: 'Установки...',
    installPlugin: 'Встановити плагін',
    dropPluginToInstall: 'Перетягніть пакет плагіна сюди, щоб встановити',
    uploadingPackage: 'Завантаження {{packageName}}...',
    readyToInstallPackage: 'Про встановлення наступного плагіна',
    pluginLoadError: 'Помилка завантаження плагіна',
    fromTrustSource: 'Будь ласка, переконайтеся, що ви встановлюєте плагіни лише з <trustSource>надійного джерела</trustSource>.',
    back: 'Задній',
    installFailedDesc: 'Плагін був встановлений не вдалося.',
    installFailed: 'Не вдалося встановити',
    installedSuccessfully: 'Монтаж успішний',
    next: 'Наступний',
  },
  installFromGitHub: {
    selectVersionPlaceholder: 'Будь ласка, оберіть версію',
    uploadFailed: 'Не вдалося завантажити файл',
    selectVersion: 'Оберіть версію',
    installNote: 'Будь ласка, переконайтеся, що ви встановлюєте плагіни лише з надійного джерела.',
    gitHubRepo: 'Репозиторій GitHub',
    installFailed: 'Не вдалося встановити',
    installPlugin: 'Встановити плагін з GitHub',
    updatePlugin: 'Оновити плагін з GitHub',
    installedSuccessfully: 'Монтаж успішний',
    selectPackage: 'Оберіть пакет',
    selectPackagePlaceholder: 'Будь ласка, оберіть пакет',
  },
  upgrade: {
    description: 'Про встановлення наступного плагіна',
    close: 'Закрити',
    successfulTitle: 'Установка успішна',
    upgrade: 'Інсталювати',
    usedInApps: 'Використовується в додатках {{num}}',
    upgrading: 'Установки...',
    title: 'Встановити плагін',
  },
  error: {
    noReleasesFound: 'Релізів не знайдено. Будь ласка, перевірте репозиторій GitHub або URL-адресу введення.',
    fetchReleasesError: 'Не вдається отримати згоди. Повторіть спробу пізніше.',
    inValidGitHubUrl: 'Невірна URL-адреса GitHub. Будь ласка, введіть дійсну URL-адресу у форматі: https://github.com/owner/repo',
  },
  marketplace: {
    sortOption: {
      mostPopular: 'Найпопулярніших',
      newlyReleased: 'Новий реліз',
      recentlyUpdated: 'Нещодавно оновлено',
      firstReleased: 'Перший реліз',
    },
    and: 'і',
    discover: 'Виявити',
    moreFrom: 'Більше від Marketplace',
    sortBy: 'Чорне місто',
    pluginsResult: 'Результати {{num}}',
    empower: 'Розширюйте можливості розробки штучного інтелекту',
    difyMarketplace: 'Dify Marketplace',
    viewMore: 'Дивитись більше',
    noPluginFound: 'Плагін не знайдено',
    verifiedTip: 'Перевірено Dify',
    partnerTip: 'Перевірено партнером Dify',
  },
  task: {
    installingWithError: 'Не вдалося встановити плагіни {{installingLength}}, успіх {{successLength}}, {{errorLength}}',
    clearAll: 'Очистити все',
    installedError: 'Плагіни {{errorLength}} не вдалося встановити',
    installError: 'Плагіни {{errorLength}} не вдалося встановити, натисніть, щоб переглянути',
    installing: 'Встановлення плагінів {{installingLength}}, 0 виконано.',
    installingWithSuccess: 'Встановлення плагінів {{installingLength}}, успіх {{successLength}}.',
  },
  from: 'Від',
  searchInMarketplace: 'Пошук у Marketplace',
  endpointsEnabled: '{{num}} наборів кінцевих точок увімкнено',
  installAction: 'Інсталювати',
  findMoreInMarketplace: 'Дізнайтеся більше в Marketplace',
  installFrom: 'ВСТАНОВИТИ З',
  install: '{{num}} встановлює',
  fromMarketplace: 'Від Marketplace',
  searchCategories: 'Категорії пошуку',
  installPlugin: 'Встановити плагін',
  searchTools: 'Інструменти пошуку...',
  search: 'Шукати',
  searchPlugins: 'Плагіни пошуку',
  allCategories: 'Всі категорії',
  metadata: {
    title: 'Плагіни',
  },
  difyVersionNotCompatible: 'Поточна версія Dify не сумісна з цим плагіном, будь ласка, оновіть до мінімальної версії: {{minimalDifyVersion}}',
  requestAPlugin: 'Запросити плагін',
  publishPlugins: 'Публікація плагінів',
}

export default translation
